/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../../core/app-context/GeneralContext';
import { APPROVE_OR_REJECT_ORDER } from './graphql';

export function useApproveOrRejectOrder() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [ApproveOrRejectOrder, { loading: apiLoading, error: apiError }] =
    useMutation(APPROVE_OR_REJECT_ORDER);

  useEffect(() => {
    setErrorMessage(apiError);
  }, [apiError]);

  useEffect(() => {
    setIsLoading(apiLoading);
    setLoading(apiLoading);
  }, [apiLoading]);

  async function approveOrRejectOrder({ orderId, choice }) {
    try {
      const res = await ApproveOrRejectOrder({
        variables: { orderId, choice },
      });
      if (res.data.approveOrRejectOrder.code === 200) {
        setSuccessMessage(res.data.approveOrRejectOrder.message);
      } else {
        setErrorMessage(res.data.approveOrRejectOrder.message);
      }
    } catch (e) {
      setErrorMessage(e.message);
    }
  }

  return {
    approveOrRejectOrder,
    loading: isLoading,
  };
}
